import { Brain, Dumbbell, Heart, Sparkles } from "lucide-react";

const PILLARS = [
  {
    icon: Brain,
    title: "Mind",
    body: "Discipline isn't built in the gym — it's forged in the spaces between sets. Mental clarity, focus, and the relentless belief that today's effort writes tomorrow's identity.",
  },
  {
    icon: Dumbbell,
    title: "Body",
    body: "Strength, symmetry, and presence. Every rep is a vote for the version of yourself you're becoming. Programs and protocols rooted in real, stage-tested results.",
  },
  {
    icon: Heart,
    title: "Soul",
    body: "Movement that means something. Lifting people up while we lift the iron — coaching, community, and a brand built to inspire positive change far beyond the mirror.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="py-24 md:py-36 relative overflow-hidden bg-gradient-to-b from-[#0A0A0A] via-[#13081f] to-[#0A0A0A]"
    >
      {/* Decorative glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1100px] h-[600px] bg-[#4C1D95] opacity-25 blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#DC2626] opacity-10 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#D4AF37]/40 text-[#D4AF37] mb-6">
            <Sparkles size={14} />
            <span className="font-accent text-xs tracking-[0.3em] uppercase">
              The Manifesto
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.9]">
            Flying <span className="text-[#D4AF37] wordmark-shadow">Higher</span>
            <br />
            To Inspire Change.
          </h2>
          <p className="text-lg md:text-2xl text-neutral-300 mt-8 max-w-3xl mx-auto leading-relaxed">
            <span className="text-white">🌈</span>{" "}
            <span className="font-display tracking-wide text-2xl md:text-3xl text-[#D4AF37]">
              Mind · Body · Soul
            </span>{" "}
            <span className="text-white">🌈</span>
            <br />
            <span className="text-base md:text-lg text-neutral-400 mt-3 inline-block">
              OMNIMUSCLE isn't just a brand. It's a movement for anyone choosing
              to rise.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {PILLARS.map((p, i) => (
            <article
              key={p.title}
              data-testid={`manifesto-pillar-${p.title.toLowerCase()}`}
              className="relative p-8 md:p-10 bg-[#0F0F0F]/80 border border-zinc-800 hover:border-[#D4AF37] backdrop-blur-sm transition-all group"
            >
              {/* Number watermark */}
              <div className="absolute top-4 right-5 font-display text-7xl text-zinc-900 group-hover:text-[#D4AF37]/10 transition-colors leading-none select-none">
                0{i + 1}
              </div>
              <p.icon
                size={36}
                className="text-[#D4AF37] mb-5 relative z-10"
                strokeWidth={1.5}
              />
              <h3 className="font-display text-4xl text-white mb-4 relative z-10">
                {p.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed relative z-10">
                {p.body}
              </p>
            </article>
          ))}
        </div>

        {/* Closing line */}
        <div className="text-center mt-16">
          <p className="font-accent italic text-xl md:text-2xl text-neutral-300 max-w-3xl mx-auto leading-relaxed">
            "Train your body. Sharpen your mind. Lift your soul — and pull
            others up with you."
          </p>
          <div className="font-accent text-xs uppercase tracking-[0.3em] mt-4">
            <span className="text-[#D4AF37]">— Roc · </span>
            <span className="font-bold" style={{ color: "#4C1D95", WebkitTextStroke: "0.4px #D4AF37" }}>
              @OmniMuscle<span className="text-[#DC2626]">_Bodybuilding</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
